import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header'
import Partners from '../Partners/Partners'
import Teamhero from "../Teamhero/Teamhero"

const Team = () => {
  return (
    <div>
        <Header />
        <Teamhero />
        <br />
        <br />
        <Partners />
        <Footer />
    </div>
  )
}

export default Team